import { createTheme } from "@mui/material/styles";

const LightTheme = createTheme({
  palette: {
    primary: {
      main: "#f9f3ee", // Main Background Color
      light: "#dad2cb4f",
    },
    bgButtonPrimary: {
      main: "#1b5e20", // Button Background
      contrastText: "#fff", // Button Text Color
    },
    borderColor: {
      main: "black",
    },
  },
  typography: {
    body1: {
      color: "black", // Header and Footer
      fontWeight: "800",
    },
    body2: {
      color: "black", // Header and Footer
      fontWeight: "800",
    },
    h4: {
      color: "black", // Page Text Color
      fontWeight: "800",
    },
    h5: {
      color: "rgb(142 23 23 / 98%)",
      fontWeight: "1000",
    },
  },
  components: {
    // Input Form Label
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "black",
          "&.Mui-focused": {
            color: "black",
          },
        },
      },
    },
    // Input component
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "black",
          },
          "& input": {
            color: "black",
          },
        },
      },
    },
  },
});

export const DarkTheme = createTheme({
  palette: {
    primary: {
      main: "#212121", // Main Background Color
      light: "#dad2cb17",
    },
    bgButtonPrimary: {
      main: "#325b83", // Button Background
      contrastText: "#fff", // Button Text Color
    },
    borderColor: {
      main: "#fff",
    },
  },
  typography: {
    body1: {
      color: "#ff9e00", // Header and Footer Colors
      fontWeight: "800",
    },
    body2: {
      color: "#fff", // Header and Footer
      fontWeight: "800",
    },
    h4: {
      color: "#fff",
      fontWeight: "800",
    },
    h5: {
      color: "#fff", // Page Color Text
      fontWeight: "1000",
    },
  },
  components: {
    // Input Form Label
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "#ff9e00",
          "&.Mui-focused": {
            color: "#ff9e00",
          },
        },
      },
    },
    // Input component
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ff9e00",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ff9e00",
          },
          "& input": {
            color: "#fff",
          },
        },
      },
    },
  },
});

export default LightTheme;
